import { Spinner } from '@zrsystem/ui';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/app/providers/auth-provider.js';
import { appPaths } from '@/app/router/paths.js';

interface RequireAuthProps {
  children: ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
        <Spinner aria-label="Carregando sessão" />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to={appPaths.login} replace state={{ from: location.pathname }} />;
  }

  return children;
}
